import { ConvexReactClient } from "convex/react";

let convexUrl: string | undefined = "";

console.log(import.meta.env.VITE_CONVEX_URL);
process.env.NODE_ENV === "production"
  ? (convexUrl = import.meta.env.VITE_CONVEX_URL)
  : (convexUrl = import.meta.env.VITE_CONVEX_URL);

if (!convexUrl) {
  throw new Error("VITE_CONVEX_URL is not set");
}

export const convex = new ConvexReactClient(convexUrl);
